import { createContext, useState } from "react";
import { DEVELOPER_PROJ_STATUS } from "../../../../constants/developer_proj_status.jsx";

const tabs = [
    { name: "Pending Release", value: DEVELOPER_PROJ_STATUS.Pending_Release },
    { name: "Active", value: DEVELOPER_PROJ_STATUS.Active },
    { name: "Suspended", value: DEVELOPER_PROJ_STATUS.Suspended },
];

export const ProjectReleaseTabContext = createContext();
export const ProjectReleaseCurrentTabContext = createContext();
export const ProjectReleaseContextProvider = (props) => {
    const [currentTab, setTab] = useState(tabs[0]);
    const setTabByValue = (value) => {
        const matchingTab = tabs.find((tab) => tab.value === value);
        if (matchingTab) {
            setTab(matchingTab);
        }
    };
    const contextValue = { currentTab, setTab, setTabByValue };
    return (
        <ProjectReleaseTabContext.Provider value={{ tabs }}>
            <ProjectReleaseCurrentTabContext.Provider value={contextValue}>
                {props.children}
            </ProjectReleaseCurrentTabContext.Provider>
        </ProjectReleaseTabContext.Provider>
    );
};
